import { App, Auth, Navigation } from "Core";
import { ServiceProvider } from "Service";
import { Configuration } from "Configuration";
import { AppContext } from "./AppContext";
import { User } from "oidc-client-ts";

/**
 * @hidden
 */
export class ChangePassword {
    public static viewModel: kendo.data.ObservableObject;

    private static textBlockCategory = "changepassword";

    private static container: JQuery;

    private static serviceProvider: ServiceProvider;

    private static appContext: AppContext;

    private static auth: Auth;

    private static minPasswordLength: number;

    public static async initialize(container: JQuery, baseUrl: string, minPasswordLength: number): Promise<void> {
        this.container = container;
        this.minPasswordLength = minPasswordLength;

        this.auth = new Auth();
        const isDmsConfig = false;
        let user: User = null;
        if (isDmsConfig) {
            user = await this.auth.init(baseUrl, "dms-config");
            if (!user) {
                return;
            }
        } else {
            user = await this.auth.init(baseUrl, "dms-web");

            if (!user) {
                return;
            }
        }

        if (isDmsConfig) {
            Configuration.baseUrl = baseUrl + "/dmsconfig";
        } else {
            Configuration.baseUrl = baseUrl;
        }

        const app = ((<any>window).app = new App());
        app.auth = this.auth;

        this.appContext = app.appContext;

        await this.appContext.initialize();

        this.serviceProvider = this.appContext.serviceProvider;

        this.viewModel = kendo.observable({
            TextBlock: null,
            isLoaded: false,
            Languages: [],
            SelectedLanguage: null,
        });
        const usedTextBlocks = [
            "pageTitle",
            "pageDescription",
            "ltrPassword",
            "ltrUserName",
            "ltrPasswordNew",
            "ltrPasswordNewRepeat",
            "password",
            "passwordNew",
            "passwordNewRepeat",
            "save",
        ];

        for (const textblock of usedTextBlocks) {
            (<any>this.viewModel)[`getTextBlock${textblock}`] = function () {
                const textBlocks = this.get("TextBlock");
                return AppContext.current.serviceProvider.TextBlock.getChecked(textBlocks, textblock, this.textBlockCategory);
            };
        }

        const loadPromise = this.serviceProvider.TextBlock.load(AppContext.current.environment.LanguageCode, this.textBlockCategory).then((textblocks) => {
            document.title =
                AppContext.current.environment.BrowserTitle +
                " " +
                this.serviceProvider.TextBlock.getChecked(textblocks[this.textBlockCategory], "pageTitle", this.textBlockCategory, true);
            this.viewModel.set("TextBlock", textblocks[this.textBlockCategory]);
            this.container.parent().removeClass("dms-hidden").addClass("animated fadeIn");
        });

        kendo.bind(this.container, this.viewModel);

        this.container.find("form").on("submit", (e) => {
            const isValid = this.checkPassword();

            if (!isValid) {
                e.preventDefault();
                return false;
            } else {
                kendo.ui.progress($("body"), true);
            }
        });

        return loadPromise;
    }

    private static checkPassword(): boolean {
        const inputNewPassword = this.container.find("#NewPassword");
        const inputNewPasswordRepeat = this.container.find("#NewPasswordRepeat");

        if (!inputNewPassword.val()) {
            Navigation.errorAsync(this.serviceProvider.TextBlock.get("passwordNewRequired", this.textBlockCategory), "Error");
            return false;
        }

        if (!inputNewPasswordRepeat.val()) {
            Navigation.errorAsync(this.serviceProvider.TextBlock.get("passwordNewRepeatRequired", this.textBlockCategory), "Error");
            return false;
        }

        if (inputNewPassword.val() !== inputNewPasswordRepeat.val()) {
            Navigation.errorAsync(this.serviceProvider.TextBlock.get("passwordRepeatError", this.textBlockCategory), "Error");
            return false;
        }
        if (inputNewPassword.val().toString().length < this.minPasswordLength) {
            Navigation.errorAsync(
                this.serviceProvider.TextBlock.get("passwordLengthNotValid", this.textBlockCategory).replace(
                    "@@length@@",
                    this.minPasswordLength.toString()
                ),
                "Password"
            );
            return false;
        }
        return true;
    }
}
